import * as React from "react";
import {Grid, Card, Button, Icon, Form, Table} from "tabler-react";
import Select from "react-select";
import SiteWrapper from "../../../SiteWrapper.react";
import Crud_Catalogos from "../../../herramientas/Crud_Catalogos";
import OperadoresForm from "../../../Catalogos/Operadores/OperadoresForm";
import ModalLay from "../../../components/ModalLay/ModalLay";
import ModalCargaMasiva from "../../../components/CargaMasivaGenerico/ModalCargaMasiva";
import TableSkeleton from "../../../components/TableSkeleton/TableSkeleton";
import { operadoresConfig } from "../../../components/CargaMasivaGenerico/configuraciones";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import "./OperadoresTransportistasPage.css";

function getSessionData(key) {
  try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
}

function getfuntion (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") {
  Crud_Catalogos(catalogo, "perfiles", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
    switch (metodo) {
      case "get": 
      if (stateVar === "funcionalidades") {
        if (Array.isArray(returnVal)) {
          for( let item of returnVal){
            if(item.nombre == "Operadores"){ return true; }
          }
        }
        window.history.back();
        window.location.href = "403";
      }  break;
      default:
        break;
    }
  }).catch(err => { console.log("Error desconocido ...."+ err); })
}

class OperadoresTransportistasPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hiddenModals: false,
      operadores: [],
      operadoresDeshabilitados: [],
      cargandoOperadores: true,
      paginaActual: 1,
      registrosPorPagina: 10,
      operadorEditar: null,
      accionModal: "nuevo",
      busqueda: "",
      idTransportista: null,
      idsTransportistas: [],
      mostrarDeshabilitados: false,
      procesando: false,
      modalConfirmar: { visible: false, operador: null, accion: null },
      showCargaMasiva: false
    };
  }

  componentDidMount() {
    const currentUser = getSessionData("currentUser");
    if (!currentUser || !currentUser[0]?.perfil?.id) return;
    getfuntion("get", "", "", "funcionalidades/Administracion_Transportista/"+currentUser[0].perfil.id, "funcionalidades");
    this.obtenerIdTransportista();
  }

  obtenerIdTransportista = () => {
    const usuario = getSessionData("usuario");
    const currentUser = getSessionData("currentUser");
    if (usuario && currentUser) {
      const plataformasIds = [...new Set(currentUser.map(c => c.plataforma?.id).filter(Boolean))];
      const promesas = plataformasIds.map(idPlat =>
        Crud_Catalogos("usuarios_transportistas/usuario/" + usuario.id + "/plataforma/" + idPlat, "", "get", "", [], "", "", "", []).catch(() => [])
      );
      Promise.all(promesas).then((resultados) => {
        const todos = resultados.flat();
        const idsUnicos = [...new Set(todos.filter(t => t.idTransportista !== null).map(t => t.idTransportista))];
        if (idsUnicos.length > 0) {
          this.setState({ idTransportista: idsUnicos[0], idsTransportistas: idsUnicos }, () => {
            this.cargarOperadores();
          });
        } else {
          this.setState({ cargandoOperadores: false });
        }
      }).catch(err => {
        console.log("Error al cargar transportistas:", err);
        this.setState({ cargandoOperadores: false });
      });
    } else {
      this.setState({ cargandoOperadores: false });
    }
  };

  cargarOperadores = () => {
    this.setState({ cargandoOperadores: true });
    
    const { idsTransportistas } = this.state;
    
    if (!idsTransportistas || idsTransportistas.length === 0) {
      this.setState({ cargandoOperadores: false });
      return;
    }
    
    // Usar endpoint directo de operadores por transportista
    const promesas = idsTransportistas.map(id =>
      Crud_Catalogos("operadores/transportista/" + id, "", "get", "", [], "", "", "", [])
        .catch(() => [])
    );

    Promise.all(promesas).then((resultados) => {
      const todos = resultados.flat();
      // Deduplicar por id de operador
      const idsVistos = new Set();
      const unicos = todos.filter(op => {
        if (idsVistos.has(op.id)) return false;
        idsVistos.add(op.id);
        return true;
      });
      unicos.sort((a, b) => b.id - a.id);

      // Separar activos de vetados
      const activos = unicos.filter(op => !op.vetado || op.vetado === "false" || op.vetado === false);
      const deshabilitados = unicos.filter(op => op.vetado === true || op.vetado === "true");
      
      this.setState({ 
        operadores: activos,
        operadoresDeshabilitados: deshabilitados,
        cargandoOperadores: false 
      });
    }).catch(err => {
      console.log("Error al cargar operadores:", err);
      this.setState({ cargandoOperadores: false });
    });
  };

  cambiarPagina = (numeroPagina) => {
    this.setState({ paginaActual: numeroPagina });
  };

  hiddenmodal = () => {
    const estabAbierto = this.state.hiddenModals;
    this.setState({ 
      hiddenModals: !this.state.hiddenModals,
      operadorEditar: null,
      accionModal: "nuevo",
      paginaActual: 1
    });
    if (estabAbierto) {
      this.cargarOperadores();
    }
  };

  abrirModalEditar = (operador) => {
    this.setState({
      operadorEditar: operador,
      accionModal: "editar"
    }, () => {
      this.setState({ hiddenModals: true });
    });
  };

  abrirModalNuevo = () => {
    this.setState({
      operadorEditar: null,
      accionModal: "nuevo",
      hiddenModals: true
    });
  };

  filtrarOperadores = () => {
    const { operadores, operadoresDeshabilitados, busqueda, mostrarDeshabilitados } = this.state;

    const lista = mostrarDeshabilitados ? operadoresDeshabilitados : operadores;

    if (!busqueda.trim()) return lista;

    const termino = busqueda.toLowerCase();
    return lista.filter(op => {
      const nombreCompleto = `${op.nombre || ''} ${op.paterno || ''} ${op.materno || ''}`.toLowerCase();
      const contacto = (op.medioComunicacion || '').toLowerCase();
      return nombreCompleto.includes(termino) || contacto.includes(termino);
    });
  };

  handleBusquedaChange = (e) => {
    this.setState({ busqueda: e.target.value, paginaActual: 1 });
  };

  abrirModalConfirmar = (operador, accion) => {
    this.setState({ modalConfirmar: { visible: true, operador, accion } });
  };

  exportarExcel = () => {
    const { operadores } = this.state;
    const data = operadores.map(op => {
      return {
        "Operador": `${op.nombre || ''} ${op.paterno || ''} ${op.materno || ''}`.trim(),
        "Contacto": op.medioComunicacion || '',
        "Licencia": op.licenciaTipo || '',
        "Vigencia": op.licenciaVigencia ? new Date(op.licenciaVigencia).toLocaleDateString() : '',
      };
    });
    if (data.length === 0) return;
    const ws = XLSX.utils.json_to_sheet(data);
    ws['!cols'] = Object.keys(data[0]).map(key => ({ wch: Math.max(key.length, 12) * 1.25 }));
    const wb = { Sheets: { 'Operadores': ws }, SheetNames: ['Operadores'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const usuario = getSessionData("usuario");
    const nombreUsuario = usuario ? (usuario.nombre || usuario.username || 'usuario') : 'usuario';
    FileSaver.saveAs(blob, `Operadores-${nombreUsuario}.xlsx`);
  };

  cerrarModalConfirmar = () => {
    this.setState({ modalConfirmar: { visible: false, operador: null, accion: null } });
  };

  ejecutarAccionConfirmada = () => {
    const { operador, accion } = this.state.modalConfirmar;

    this.setState({ procesando: true });
    this.cerrarModalConfirmar();

    const operadorDTO = {
      ...operador,
      vetado: accion === "deshabilitar" ? true : false
    };

    Crud_Catalogos("operadores", "", "put", "", operadorDTO, "", "", "", [])
      .then(() => this.cargarOperadores())
      .catch(err => {
        console.error("Error al " + accion + " operador:", err);
      })
      .finally(() => this.setState({ procesando: false }));
  };

  render() {
    const { operadores, operadoresDeshabilitados, cargandoOperadores, paginaActual, registrosPorPagina, operadorEditar, accionModal, busqueda, mostrarDeshabilitados } = this.state;

    // Filtrar y paginar
    const operadoresFiltrados = this.filtrarOperadores();
    const indiceUltimo = paginaActual * registrosPorPagina;
    const indicePrimero = indiceUltimo - registrosPorPagina;
    const operadoresPaginados = operadoresFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(operadoresFiltrados.length / registrosPorPagina);

    return (
      <SiteWrapper>
        <Grid.Row>
          <Grid.Col width={12}>
            <Card>
              <Card.Header>
                <Card.Title>Catálogo de Operadores</Card.Title>
                <Card.Options>
                  <div onClick={this.exportarExcel} style={{ marginRight: '10px' }}>
                    <Button size="sm" color="purple">
                      <Icon name="download" /> Exportar
                    </Button>
                  </div>
                  <div onClick={() => this.setState({ showCargaMasiva: true })} style={{ marginRight: '10px' }}>
                    <Button size="sm" color="success">
                      <Icon name="upload" /> Carga Masiva
                    </Button>
                  </div>
                  
                  <div onClick={this.abrirModalNuevo}>
                    <Button 
                      size="sm" 
                      color="primary"
                    >
                      <Icon name="plus" /> Nuevo
                    </Button>
                  </div>
                  <ModalLay
                    tamanio="60%"
                    title={accionModal === "nuevo" ? "Nuevo Operador" : "Editar Operador"}
                    name={<span style={{display: 'none'}}></span>}
                    hiddenModal={this.state.hiddenModals}
                    Fclose={this.hiddenmodal}
                    formulario={OperadoresForm}
                    datosForm={{
                      accion: accionModal,
                      elementos: operadorEditar,
                      getfuntion: Crud_Catalogos,
                      stor: {},
                      cerrarModal: this.hiddenmodal,
                      idTransportista: this.state.idTransportista,
                      multiPlataforma: true
                    }}
                  />
                </Card.Options>
              </Card.Header>
              <Card.Body>
                {/* Buscador */}
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                  <div style={{ maxWidth: '400px', flex: 1 }}>
                    <Form.Input
                      icon="search"
                      placeholder="Buscar operador..."
                      value={busqueda}
                      onChange={this.handleBusquedaChange}
                      disabled={cargandoOperadores}
                    />
                  </div>
                  <div className="switch-container-op">
                    <label className="switch-toggle-op">
                      <input
                        type="checkbox"
                        checked={mostrarDeshabilitados}
                        onChange={() => this.setState({ mostrarDeshabilitados: !mostrarDeshabilitados, paginaActual: 1 })}
                      />
                      <span className="switch-slider-op"></span>
                    </label>
                    <span style={{ fontSize: '14px', color: '#6c757d' }}>
                      Mostrar deshabilitados {operadoresDeshabilitados.length > 0 && <span className="badge-deshabilitado-op">{operadoresDeshabilitados.length}</span>}
                    </span>
                  </div>
                </div>

                {/* Tabla de operadores */}
                {cargandoOperadores ? (
                  <TableSkeleton
                    title="Operadores"
                    headers={['Operador', 'Contacto', 'Licencia', 'Vigencia', 'Acciones']}
                    isLoading={cargandoOperadores}
                  />
                ) : (
                  <>
                    <div style={{ 
                      textAlign: 'center', 
                      fontSize: '32px', 
                      fontWeight: 'bold', 
                      marginBottom: '30px',
                      color: '#467fcf'
                    }}>
                      Total de Operadores: {operadores.length}
                    </div>
                    
                    {operadoresFiltrados.length === 0 && operadores.length === 0 ? (
                  <div style={{padding: '40px', textAlign: 'center'}}>
                    <Icon name="users" style={{fontSize: '48px', color: '#ccc'}} />
                    <h3>No hay operadores registrados</h3>
                    <p>Usa el botón "Nuevo" para agregar operadores</p>
                  </div>
                ) : operadoresFiltrados.length === 0 ? (
                  <div style={{padding: '40px', textAlign: 'center'}}>
                    <Icon name="search" style={{fontSize: '48px', color: '#ccc'}} />
                    <h3>No se encontraron operadores</h3>
                    <p>Intenta con otro término de búsqueda</p>
                  </div>
                ) : (
                  <div className="operadores-table-container">
                    <Table className="operadores-table" responsive>
                      <Table.Header>
                        <Table.Row>
                          <Table.ColHeader>Operador</Table.ColHeader>
                          <Table.ColHeader>Contacto</Table.ColHeader>
                          <Table.ColHeader>Licencia</Table.ColHeader>
                          <Table.ColHeader>Vigencia</Table.ColHeader>
                          <Table.ColHeader>Acciones</Table.ColHeader>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {operadoresPaginados.map((op) => {
                          return (
                            <Table.Row key={op.id}>
                              <Table.Col>
                                <div style={{ fontWeight: '600' }}>
                                  {op.nombre || '-'} {op.paterno || ''} {op.materno || ''}
                                </div>
                              </Table.Col>
                              <Table.Col>{op.medioComunicacion || '-'}</Table.Col>
                              <Table.Col>{op.licenciaTipo || '-'}</Table.Col>
                              <Table.Col>
                                {op.licenciaVigencia 
                                  ? new Date(op.licenciaVigencia).toLocaleDateString() 
                                  : '-'}
                              </Table.Col>
                              <Table.Col>
                                <Button 
                                  size="sm" 
                                  color="primary" 
                                  icon="edit"
                                  onClick={() => this.abrirModalEditar(op)}
                                >
                                  Editar
                                </Button>
                                {' '}
                                {mostrarDeshabilitados ? (
                                  <Button 
                                    size="sm" 
                                    color="success" 
                                    icon="check"
                                    disabled={this.state.procesando}
                                    onClick={() => this.abrirModalConfirmar(op, "habilitar")}
                                  >
                                    Habilitar
                                  </Button>
                                ) : (
                                  <Button 
                                    size="sm" 
                                    color="danger" 
                                    icon="x"
                                    disabled={this.state.procesando}
                                    onClick={() => this.abrirModalConfirmar(op, "deshabilitar")}
                                  >
                                    Deshabilitar
                                  </Button>
                                )}
                              </Table.Col>
                            </Table.Row>
                          );
                        })}
                      </Table.Body>
                    </Table>

                    {/* Paginación */}
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      marginTop: '20px',
                      padding: '15px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px'
                    }}>
                      <div style={{ fontSize: '14px', color: '#6c757d' }}>
                        Mostrando {indicePrimero + 1} - {Math.min(indiceUltimo, operadoresFiltrados.length)} de {operadoresFiltrados.length} operadores
                      </div>
                      <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                        <Button
                          size="sm"
                          color="secondary"
                          disabled={paginaActual === 1}
                          onClick={() => this.cambiarPagina(paginaActual - 1)}
                        >
                          <Icon name="chevron-left" />
                        </Button>
                        
                        <span style={{ 
                          padding: '0 10px', 
                          fontSize: '14px', 
                          fontWeight: '600',
                          color: '#495057'
                        }}>
                          {paginaActual} / {totalPaginas}
                        </span>
                        
                        <Button
                          size="sm"
                          color="secondary"
                          disabled={paginaActual >= totalPaginas || totalPaginas === 0}
                          onClick={() => this.cambiarPagina(paginaActual + 1)}
                        >
                          <Icon name="chevron-right" />
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                </>
                )}
              </Card.Body>

              {/* Modal de confirmación */}
              {this.state.modalConfirmar.visible && (
                <div style={{
                  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                  backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                  justifyContent: 'center', alignItems: 'center', zIndex: 9999
                }}>
                  <div style={{
                    backgroundColor: 'white', borderRadius: '12px', padding: '30px',
                    maxWidth: '400px', width: '90%', textAlign: 'center', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
                  }}>
                    <Icon 
                      name="alert-triangle"
                      style={{ 
                        fontSize: '48px', 
                        color: '#dc3545',
                        marginBottom: '15px'
                      }} 
                    />
                    <h4 style={{ marginBottom: '10px' }}>
                      Deshabilitar Operador
                    </h4>
                    <p style={{ color: '#6c757d', marginBottom: '25px' }}>
                      ¿Deseas deshabilitar a <strong>{this.state.modalConfirmar.operador?.nombre} {this.state.modalConfirmar.operador?.paterno}</strong>?
                    </p>
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                      <Button size="sm" color="secondary" onClick={this.cerrarModalConfirmar}>
                        Cancelar
                      </Button>
                      <Button 
                        size="sm" 
                        color="danger"
                        onClick={this.ejecutarAccionConfirmada}
                      >
                        Deshabilitar
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </Grid.Col>
        </Grid.Row>
        
        {/* Modal de Carga Masiva */}
        <ModalCargaMasiva
          isOpen={this.state.showCargaMasiva}
          onClose={() => this.setState({ showCargaMasiva: false })}
          title="Carga Masiva de Operadores"
          subtitle="Importa múltiples operadores desde un archivo Excel"
          config={operadoresConfig(this.state.idTransportista)}
          onDataLoaded={() => this.cargarOperadores()}
        />
      </SiteWrapper>
    );
  }
}

export default OperadoresTransportistasPage;
